import BackButton from "components/Button/BackButton"
import DeleteButton from "components/Button/DeleteButton"
import SaveButton from "components/Button/SaveButton"
import { useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import { EmptyString, FormTypeAdd, FormTypeEdit, InsertDateFormat, StatusCodeActive, StatusCodeDelete } from "utils/Constant"
import moment from "moment"
import { money } from "utils/helpers"
import UnDeleteButton from "components/Button/UnDeleteButton"
import Select from 'react-select'
import { useCallApi } from "api/apiHooks"
import { useModal } from "utils/context/ModalContext"
import { FormCard, MainBodyCard, PagesFormTitle } from "components/Cards"
import { CommonService } from "services/CommonService/CommonService"
import DatePicker from "components/Input/DatePicker"
import { ExpenseService } from "services/ExpenseService/ExpenseService"
import { useVariable } from "utils/context/VariableContext"

export default function ExpenseForm(){
    const navigate = useNavigate()
    const { locationId } = useVariable()
    const debounceRef = useRef(null)
    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchCommon } = CommonService()
    const { fetchCreateExpense, fetchUpdateExpense, fetchDeleteExpense, fetchExpenseById } = ExpenseService()
    const { fetchLocationList } = useCallApi()

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let expenseId = queryString.get("expenseId")

    const [expenseDate, setExpenseDate] = useState(new Date())
    const [amount, setAmount] = useState('')
    const [categoryOptions, setCategoryOptions] = useState([])
    const [categoryId, setCategoryId] = useState('')
    const [remark, setRemark] = useState('')
    const [status, setStatus] = useState(EmptyString)
    const [createDate, setCreateDate] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)
    const [locationOptions, setLocationOptions] = useState([])
    const [selectedlocationId, setSelectedLocationId] = useState('1')

    const saveBtnClick = async () => {
        if (validateForm()){
            const isConfirmed = await confirm()

            if (isConfirmed) {
                showLoading()

                try {
                    if (formType === FormTypeAdd){
                        const res = await createExpense()
                        if (!res) return
                    }else{
                        const res = await updateExpense()
                        if (!res) return
                    }
                    
                    showSuccess({
                        onSuccess: () => {
                            navigate('/expense')
                        }
                    })
                } finally {
                    hideLoading()
                }
            }
        }
    }
    const deleteBtnClick = async () => {
        const isConfirmed = await confirm()

        if (isConfirmed) {
            showLoading()

            try {
                const res = await deleteExpense()
                if (!res) return
                
                showSuccess({
                    onSuccess: () => {
                        navigate('/expense')
                    }
                })
            } finally {
                hideLoading()
            }
        }
    }
    const backBtnClick = () => {
        navigate('/expense')
    }

    function validateForm(){
        
        return true
    }

    const getCategoryOptions = async () => {
        const res = await fetchCommon('expense_category_options')
        if (!res) return

        const data = res.data
        const options = []
        data.map((x) => options.push({label: x.commonText, value: x.commonValue}))
        setCategoryOptions(options)
    }
    const createExpense = async () => {
        const res = await fetchCreateExpense(
            moment(expenseDate).format(InsertDateFormat),
            categoryId,
            amount.replaceAll(',' , ''),
            remark, 
            parseInt(locationId)
        )
        return res
    }
    const updateExpense = async () => {
        const res = await fetchUpdateExpense(
            expenseId,
            moment(expenseDate).format(InsertDateFormat),
            categoryId,
            amount.replaceAll(',' , ''),
            remark, 
            parseInt(selectedlocationId)
        )
        return res
    }
    const deleteExpense = async () => {
        const res = await fetchDeleteExpense(
            expenseId,
            status
        )
        return res
    }
    const getExpenseById = async () => {
        const res = await fetchExpenseById(expenseId)
        if (!res) return false

        const data = res.data

        setExpenseDate(data.expenseDate)
        setCategoryId(String(data.categoryId))
        setAmount(money(data.amount))
        setRemark(data.remark)
        setSelectedLocationId(String(data.locationId))
        setStatus(data.status)
        setCreateDate(data.createDate)
        setUpdateBy(data.updateBy)
        setUpdateDate(data.updateDate)

        return true
    }
    const getLocationList = async () => {
        const res = await fetchLocationList('', '1', 500, 0)
        if (!res) return false 

        const data = res.data.listData
        const options = data.map((data) => ({label: data.locationName, value: String(data.locationId)}))

        setLocationOptions(options)
        return true
    }

    useEffect(() => {
        const firstLoad = async () => {
            try {
                showLoading()

                const res = await getCategoryOptions()

                if (formType ===  FormTypeEdit){
                    const resGetLocation = await getLocationList()
                    if (!resGetLocation) return

                    const resGetExpense = await getExpenseById()
                    if (!resGetExpense) return 
                }
            } finally {
                hideLoading()
            }
        }

        firstLoad()
    }, [])

    return (
        <MainBodyCard>
            <PagesFormTitle
                title='Detail Pengeluaran'
                formType={formType}
                status={status}
                createDate={createDate}
                updateDate={updateDate}
                updateBy={updateBy}
            />

            <div className="mt-5 flex flex-col gap-3">
                <FormCard title='Tanggal Pengeluaran'>
                    <DatePicker className='w-full' value={expenseDate} onChange={setExpenseDate} />
                </FormCard>

                <FormCard title='Kategori'>
                    <Select options={categoryOptions} value={categoryOptions.find(opt => opt.value === categoryId)} onChange={(e) => setCategoryId(e.value)} />
                </FormCard>

                <FormCard title='Jumlah'>
                    <input className="input" value={amount} onChange={(e) => setAmount(money(e.target.value))} />
                </FormCard>

                <FormCard title='Catatan'>
                    <input className="input" value={remark} onChange={(e) => setRemark(e.target.value)} />
                </FormCard>

                {formType === FormTypeEdit && (
                    <FormCard title='Lokasi'>
                        <Select options={locationOptions} value={locationOptions.find(opt => opt.value === selectedlocationId)} onChange={(e) => setSelectedLocationId(e.value)} />
                    </FormCard>
                )}
            </div>
                
            <div className="mt-5 flex flex-wrap justify-end w-full gap-2">
                <SaveButton onClick={saveBtnClick} visible={true} />
                <DeleteButton onClick={deleteBtnClick} visible={ formType === FormTypeAdd ? false : (status === StatusCodeActive ? true : false) } />
                <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === StatusCodeDelete ? true : false) : false} />
                <BackButton onClick={backBtnClick}  />
            </div>
        </MainBodyCard>
    )
}